import { Component, ViewChild,OnInit,ElementRef } from '@angular/core';
import { SelectItem, LazyLoadEvent,Message } from 'primeng/primeng';
import { PositionService} from '../services/position.service';
import { DeviceService } from '../services/device.service';
import { UserService } from '../services/user.service';
import * as jsPDF from 'jspdf';
import { AddressService } from '../services/address.service';
import { Table } from 'primeng/components/table/table';
import * as XLSX from 'xlsx';
import { GeofenceService } from '../services/geofence.service';

@Component({
selector: 'app-position-report',
templateUrl: './position-report.component.html',
styleUrls: ['./position-report.component.css']
})
export class PositionReportComponent implements OnInit {

fileName:string;
options: any;
overlays: any[];
position:any;
totalRecords: number;
positions : any [];
devices: SelectItem[];
dateOptions: SelectItem[];
dateOption: any;
idDevice: String;
disabledInitialDate: boolean;
disabledFinalDate: boolean;
initialDate: Date;
finalDate: Date;
msgs: Message[] = [];
blockedDocument: boolean = false;
cols: any[];
displayLocation: boolean=false;
maxDays: number=10;
loading: boolean;
geofences:any[];
alarmsQuantity:number;

@ViewChild('dt') table: Table;
@ViewChild('content') content: ElementRef;

constructor(private positionService:PositionService,private deviceService : DeviceService,
  private userService: UserService, private addressService:AddressService, private geofenceService:GeofenceService
) { }

  ngOnInit() {
    this.cols = [
            { field: 'nameDevice', header: 'NOMBRE' },
            { field: 'deviceTime', header: 'FECHA/HORA' },
            { field: 'latLng', header: 'POSICION' },
            { field: 'speed', header: 'VELOCIDAD' },
            { field: 'address', header: 'DIRECCION' }
        ];
    this.dateOptions = [
      {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
      {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
      {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
      {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
    ];

    this.devices = [];
    this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.devices.forEach(item => {
        this.devices.push({label: item.name, value: item.idDevice});
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });

    this.geofences = [];
    this.geofenceService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      this.geofences = [...response.geofences];
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });

    this.dateOption = 'Y';
    this.changeDate();
  }

  changeDate(){
    this.disabledInitialDate = true;
    this.disabledFinalDate = true;
    if(this.dateOption == 'T'){
      this.initialDate = new Date();
      this.finalDate = new Date();
      this.initialDate.setHours(0,0,0);
      this.finalDate.setHours(23,59,59);
    }else if(this.dateOption == 'Y'){
      this.initialDate = new Date();
      this.finalDate = new Date();
      this.initialDate.setDate(this.initialDate.getDate() - 1);
      this.initialDate.setHours(0,0,0);
      this.finalDate.setDate(this.finalDate.getDate() - 1);
      this.finalDate.setHours(23,59,59);
    }else if(this.dateOption == '7'){
      this.initialDate = new Date();
      this.finalDate = new Date();
      this.initialDate.setDate(this.initialDate.getDate() - 6);
      this.initialDate.setHours(0,0,0);
      this.finalDate.setHours(23,59,59);
    }else{
      this.disabledInitialDate = false;
      this.disabledFinalDate = false;
    }
  }

  diferenciaEntreFechasEnDias(a:Date, b:Date):number{
    return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
  }

  buscar(){
    if(this.table){
      this.table.first=1;
    }
    this.fileName="posiciones_";
    this.devices.forEach(item =>{
      if(item.value == this.idDevice){
        this.fileName = this.fileName+item.label;
      }
    });

    if(this.diferenciaEntreFechasEnDias(this.initialDate,this.finalDate) > this.maxDays){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los "+this.maxDays+" dias"}];
      return;
    }
    if(this.initialDate >= this.finalDate){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"La fecha final debe ser superior a la fecha inicial"}];
      return;
    }

    /*this.blockedDocument = true;
    this.positionService.countFindBetweenDates(this.idDevice,this.initialDate,this.finalDate).then(data => {
      let response: any = data;
      this.totalRecords = response.count;
      if(this.totalRecords > 0 ){
        this.loadPositions(0,300);
      }else{
        this.msgs = [{severity:'info', summary:'INFO', detail:"No se encontraron registros"}];
        this.blockedDocument = false;
        this.loading = false;
      }
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Error de conexión, comprueba la conexión a internet y vuelva a intentar"}];
      this.blockedDocument = false;
      this.loading = false;
    });*/

    this.blockedDocument = true;

    this.positionService.findBetweenDates(this.idDevice,this.initialDate,this.finalDate,null,null).then(data => {
      let response: any = data;
      if(response.status != "OK"){
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        this.blockedDocument = false;
        return;
      }
      this.positions = [];
      this.alarmsQuantity = 0
      response.positions.forEach(item => {
        item.latitude = item.latitude.toFixed(6);
        item.longitude = item.longitude.toFixed(6);
        item.speed = item.speed.toFixed(2);
        item.latLng = item.latitude+", "+item.longitude

        let itemExtended = item.extended.find(item => item.key == "idGeofence");

        if(itemExtended){
          let geofence = this.geofences.find(item => item.idGeofence == itemExtended.value);
          itemExtended.value = itemExtended.value + " - "+geofence.name;
        }

        let alarmExtended = item.extended.find(item => item.key == "alarm");
        if(alarmExtended){
          this.alarmsQuantity += 1;
        }

        this.positions.push(item);
      });
      this.totalRecords = this.positions.length;
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Error de conexión, comprueba la conexión a internet y vuelva a intentar"}];
      this.blockedDocument = false;
    });
  }

  showInMap(position:any){
    this.overlays = [];
    this.displayLocation = true;
    let latLng = new google.maps.LatLng(position.latitude, position.longitude);
    this.options = {
      zoom: 13,
      center:latLng
    };
    let marker = new google.maps.Marker({position: latLng});
    this.position = position;
    this.overlays.push(marker);
  }

  hide(){
    this.displayLocation = false;
  }

  getAddress(position:any){
    this.blockedDocument = true;
    this.addressService.findAddressByCoordinates(position).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          position.address = response.address;
          this.msgs = [{severity:'info', summary:'INFO', detail:'Dirección obtenida Exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
    });;
  }

  downloadPDF(){
    let doc = new jsPDF();
    let specialElementHandlers= {
      '#editor':function(element,renderer){
        return true;
      }
    };

    let content = this.content.nativeElement;

    doc.fromHTML(content.innerHtml,15,15,{
      'width':190,
      'elementHandlers':specialElementHandlers
    });

    doc.save('test.pdf');
  }

  exportXLS(){
    let records = [];
    this.positions.forEach(item=>{
      let data = {};
      this.cols.forEach(col => {
        data[col.header] = item[col.field];
      });

      item.extended.forEach(itemExtended =>{
        data[itemExtended.key] = itemExtended.value;
      });
      records.push(data);
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.fileName+".xlsx");
  }

  /*loadPositionsLazy(event: LazyLoadEvent) {
    this.loadPositions(event.first,event.rows);
  }

  loadPositions(first: number, rows:number){
    this.blockedDocument = true;
    this.loading = true;
    this.positions = [];
    this.positionService.findBetweenDates(this.idDevice,this.initialDate,this.finalDate,first,rows).then(data => {
      let response: any = data;
      if(response.status != "OK"){
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        this.blockedDocument = false;
        this.loading = false;
        return;
      }
      response.positions.forEach(item => {
        item.latitude = item.latitude.toFixed(6);
        item.longitude = item.longitude.toFixed(6);
        item.speed = item.speed.toFixed(2);
        item.latLng = item.latitude+", "+item.longitude
        /*item.extended.forEach(itemExtended =>{
          item[itemExtended.key]=itemExtended.value;
        });*
        this.positions.push(item);
      });

      /*this.positions[0].extended.forEach(itemExt =>{
        this.cols.push({ field: itemExt.key, header: itemExt.key });
      });*
      this.blockedDocument = false;
      this.loading = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Error de conexión, comprueba la conexión a internet y vuelva a intentar"}];
      this.blockedDocument = false;
      this.loading = false;
    });
  }
*/
}



// WEBPACK FOOTER //
// ./src/app/position-report/position-report.component.ts